/**
 *
 * SongListItem
 *
 */
import * as React from 'react';
import styled from 'styled-components/macro';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope, faPlay, faSparkles, faPause} from "@fortawesome/pro-solid-svg-icons";
import {Button} from "@mui/material";
import {DisplaySongInfo} from "app/components/GlobalAudioPlayer/slice/types";
import {useDispatch, useSelector} from "react-redux";
import {useGlobalAudioSlice} from "app/components/GlobalAudioPlayer/slice";
import {selectCurrentSong, selectIsPlaying} from "app/components/GlobalAudioPlayer/slice/selectors";
import {Api} from "../../../store/api";
import {useState} from "react";
import {useAcapellasSlice} from "app/pages/AcapellasPage/slice";
import {
  getPreviewUrlOfAcapellaStack,
  getStatusOfAcapellaStack
} from "app/components/SongPreviewCard/getStatusOfAcapellaStack";
import {Orbit, Pulsar} from "@uiball/loaders";

interface Props {
  song: any,
  previewVoice: any,
  onCustomize: any,
}
export function SongListItem(props: Props) {
  const { song, previewVoice } = props;
  const { title, artist_info } = song;
  const acapella_stack = song?.acapella_stack && song?.acapella_stack[0];

  const dispatch = useDispatch();
  const { actions: globalAudioActions } = useGlobalAudioSlice()
  const { actions: acapellaActions } = useAcapellasSlice()
  const currentSong = useSelector(selectCurrentSong)
  const isPlaying = useSelector(selectIsPlaying)
  const [isPresaving, setIsPresaving] = useState(false)
  const [isQueueingPreview, setIsQueueingPreview] = useState(false)
  // If multiple previews are returned, get highest ID for most recent one
  const jobs = acapella_stack && acapella_stack.acapella_stack_jobs && acapella_stack.acapella_stack_jobs.filter(j => j.job.type === 'acapella-stack-preview-mixer')
  console.log(jobs)
  const mixdownPreviewFiles = jobs && jobs.map(j => j.job.audio_file_output[0].audio_file.storagePublicUrl)
  // ChatGPT: const highestIdObject = arrayOfObjects.reduce((a, b) => (a.id > b.id ? a : b), {});
  let mainAudioPreviewUrl = mixdownPreviewFiles && mixdownPreviewFiles[0]
  const isThisPlaying = isPlaying && currentSong?.url === mainAudioPreviewUrl


  const handleGeneratePreview = () => {
    setIsQueueingPreview(true)
    Api.generateAcapellaStackPreview(previewVoice.uuid, acapella_stack.uuid).then(() => {
      //refresh songs
      dispatch(acapellaActions.searchSongs({}))
      setIsQueueingPreview(false)
    }).catch((e) => {
      setIsQueueingPreview(false)
    })
  }

  const handlePlay = () => {
    // Create DisplaySong object for main preview
    const displaySong :DisplaySongInfo = {
      title: title,
      singer: artist_info,
      url: mainAudioPreviewUrl,
      coverUrl: "",
      acapellaStack: acapella_stack,
    }

    dispatch(globalAudioActions.setCurrentSong(displaySong))
    dispatch(globalAudioActions.setIsPlaying(true))
  }

  const handlePause = () => {
    dispatch(globalAudioActions.setIsPlaying(false))
  }

  const handleNotify = () => {
    setIsPresaving(true)
    Api.presaveSong(song.uuid, previewVoice?.uuid).then(() => {
      dispatch(acapellaActions.setSongParamLocal({
        uuid: song.uuid,
        key: 'is_presaved',
        value: true,
      }))
      setIsPresaving(false)
    }).catch((e) => {
      setIsPresaving(false)
    })
  }

  // TODO dynamically render action buttons
  let notifyMeButton = (
      <Button onClick={handleNotify} startIcon={<FontAwesomeIcon icon={faEnvelope} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="outlined" >
        Notify Me
      </Button>
  );
  if (isPresaving) {
    notifyMeButton = (
        <Button disabled={true} startIcon={<FontAwesomeIcon icon={faEnvelope} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="outlined" >
          Notifying...
        </Button>
    );
  }
  if (song.is_presaved) {
    notifyMeButton = (
        <Button color="success" startIcon={<FontAwesomeIcon icon={faEnvelope} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="text" >
          You'll be notified
        </Button>
    );
  }

  let mainActionButton = notifyMeButton
  let borderElement: any = null
  if (acapella_stack) {
    if (!acapella_stack?.acapella_stack_jobs || acapella_stack.acapella_stack_jobs.length == 0) {
      // if we have an acapella stack to sell and no jobs have been created (no previews), show generate preview button
      mainActionButton = (
          <Button disabled={isQueueingPreview} onClick={handleGeneratePreview} startIcon={<FontAwesomeIcon icon={faSparkles} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="text" >
            {isQueueingPreview ? 'Generating ' : 'Generate '} Preview
          </Button>
      )
    } else {

      let acapellaStackPreviewStatus = getStatusOfAcapellaStack(acapella_stack)
      console.log('status: ', acapellaStackPreviewStatus)
      if (acapellaStackPreviewStatus === 'CREATED') {
        // borderElement = <div className="animate-border-pulse-small" style={{ borderRadius: '5px !important' }}></div>
        mainActionButton = (
            <Button disabled={true} color="success" startIcon={
              <Pulsar
                size={18}
                speed={2}
                color="#F5E1FF"
              />
            } sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="text" >
              Preview Queued
            </Button>
        )
      } else if (acapellaStackPreviewStatus === 'STARTED') {
        borderElement = <div className="animate-border-trail-small"></div>
        mainActionButton = (
            <Button disabled={true} color="primary" startIcon={<FontAwesomeIcon icon={faSparkles} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="text" >
              Generating
            </Button>
        )
      } else if (acapellaStackPreviewStatus === 'COMPLETED') {
        mainAudioPreviewUrl = getPreviewUrlOfAcapellaStack(acapella_stack)
        // borderElement = null
        // if we have an acapella stack and a preview ready in this voice,
        mainActionButton = (
            <Button onClick={isThisPlaying ? handlePause : handlePlay} startIcon={<FontAwesomeIcon icon={isThisPlaying ? faPause : faPlay} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="text" >
              {isThisPlaying ? 'Playing' : 'Play'} in my voice
            </Button>
        )
      }

    }
  }

  return <SongContainer>
    <div className="animate-border-container">
      <SongRow>
        <SongInfo>
          <SongTitle>
            {title}
          </SongTitle>
          <SongArtist>
            {song.artist_info}
          </SongArtist>
        </SongInfo>
        <ActionsContainer>
          {mainActionButton}
        </ActionsContainer>
      </SongRow>
      {borderElement}
    </div>
  </SongContainer>;
}

const SongContainer = styled.div`

  //border-top: 1px solid rgba(245, 225, 255, 0.34);
  //
  //padding-bottom: 10px;
  //padding-top: 10px;
  position: relative;
`;

const SongRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  
  height: 70px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  // READY TO PLAY
  border-radius: 6px;
  border: 1px solid #000;
  background: linear-gradient(90deg, #411D5344 0%, #732D9744 100%);
  
  //GENERATE PREVIEW 
  //border-radius: 6px;
  //border: 1px solid rgba(245, 225, 255, 0.17);
  //background: #281534;

  //NOTIFY ME
  //border-radius: 6px;
  //border: 1px solid rgba(245, 225, 255, 0.34);
  //background: none;
  
  &:hover {
    border-radius: 6px;
    border: 1px solid #000;
    background: linear-gradient(90deg, #411D53 0%, #732D97 100%);
  }
`;

const SongInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  
  margin-left: 20px;
`;

const SongTitle = styled.div`
  color: #FFF;

  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
const SongArtist = styled.div`
  color: rgba(245, 225, 255, 0.74);

  font-family: Raleway;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 20px;
`